// using for portal pricing
export const configConstants = {
  GET_CONFIG_ALL_REQUEST: 'GET_CONFIG_ALL_REQUEST',
  GET_CONFIG_ALL_SUCCESS: 'GET_CONFIG_ALL_SUCCESS',
  GET_CONFIG_ALL_FAILURE: 'GET_CONFIG_ALL_FAILURE',

  UPDATE_CONFIG_REQUEST: 'UPDATE_CONFIG_REQUEST',
  UPDATE_CONFIG_SUCCESS: 'UPDATE_CONFIG_SUCCESS',
  UPDATE_CONFIG_FAILURE: 'UPDATE_CONFIG_FAILURE',
};
